import {useContext} from 'react';
import {ErrorInformerPushContext} from './ErrorInformerPushContext';

export function useErrorInformerPush() {
	const context = useContext(ErrorInformerPushContext);
	if (!context) {
		// Return empty function to avoid error without context (SSR case)
		// eslint-disable-next-line @typescript-eslint/no-empty-function,no-unused-vars
		return (error: unknown) => {};
	}

	return context.push;
}

useErrorInformerPush.displayName = 'useErrorInformerPush';
